/* eslint-disable no-redeclare */
import { z } from 'zod';

export const Irpid = z.string();

export type Irpid = z.infer<typeof Irpid>;
